import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import * as React from "react"

import { cn } from '#app/utils/misc.tsx'
import { Icon } from "./icon"

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn("grid gap-2", className)}
      {...props}
      ref={ref}
    />
  )
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

type RadioGroupItemExtend = React.ForwardRefExoticComponent<RadioGroupPrimitive.RadioGroupItemProps & React.RefAttributes<HTMLButtonElement> & {
    hideCheck?: boolean;
    customActive?: boolean;
}>

const RadioGroupItem = React.forwardRef<
  React.ElementRef<RadioGroupItemExtend>,
  React.ComponentPropsWithoutRef<RadioGroupItemExtend>
>(({ className, hideCheck, customActive, children, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'relative flex space-x-4 items-center justify-between',
        customActive ? '' : 'h-10 px-4 py-2 border border-input rounded-lg bg-background hover:bg-accent hover:text-accent-foreground',
        'data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:hover:bg-primary/80 data-[state=checked]:hover:text-primary-foreground',
        className
      )}
      {...props}
    >
      { children }
      { !hideCheck && 
        <RadioGroupPrimitive.Indicator className="flex items-center">
          <Icon name="check-circle" size="lg" />
        </RadioGroupPrimitive.Indicator>
      }
    </RadioGroupPrimitive.Item>
  )
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
